module.exports = __webpack_public_path__ + "static/media/delete_outline_24px.15911294.svg";